import axiosInstance from "../config/axiosInstance";
import { APIROUTE } from "../config/config";

export const createTransferService = async (payload) => {
  return (await axiosInstance.post(APIROUTE.transaction, payload)).data;
};  // (positive value) agent to user and (negative value) user to agent

export const createTransferUtoUService = async (payload) => {
  return (await axiosInstance.post(APIROUTE.UserToUser, payload)).data;
}; // user to user

export const getTransferService = async (signal) => {
  return (await axiosInstance.get(`${APIROUTE.transaction}`, signal)).data; 
}

export const getTransferUtoUService = async (signal) => {
  return (await axiosInstance.get(`${APIROUTE.UserToUser}`, signal)).data; 
}

export const getTransferFromBetweenService = async (startDate, endDate, type, signal) => {
  return (await axiosInstance.get(`${APIROUTE.transaction}/startDate/${startDate}/endDate/${endDate}/type/${type}`, signal)).data; 
}

export const getTransferToBetweenService = async (startDate, endDate, type, signal) => {
  return (await axiosInstance.get(`${APIROUTE.transaction}/startDate/${startDate}/endDate/${endDate}/type/${type}`, signal)).data; 
}

export const updateTransferService = async (payload) => {
  let filteredPayload = {
    "transactionTypeId" : payload.transactionTypeId,
    "transactionType": payload.transactionType,
  }
  return (await axiosInstance.put(`${APIROUTE.transaction}/${payload.transactionTypeId}`, filteredPayload)).data;
};